export default function (electricity, chart_id) {
  if (window["myElectricCurrentChart" + chart_id]) {
    window["myElectricCurrentChart" + chart_id].destroy();
  }

  let logConfig = {
    data: {
      labels: [],
      times: [],
      datasets: [
        {
          label: "功率(KWatt)",
          tension: 0.1,
          backgroundColor: "rgba(75, 192, 192, 0.2)",
          borderColor: "rgb(75, 192, 192)",
          pointRadius: 2,
          pointBackgroundColor: "rgba(75, 192, 192, 0.2)",
          pointBorderColor: "rgb(75, 192, 192)",
          pointHoverRadius: 5,
          pointHoverBackgroundColor: "rgb(75, 192, 192)",
          pointHitRadius: 50,
          pointBorderWidth: 2,
          data: [],
          type: "line",
          order: 1,
          yAxisID: "y", // default
        },
        {
          label: "電流(Ampere)",
          tension: 0.1,
          backgroundColor: "rgba(187, 192, 42, 0.2)",
          borderColor: "rgb(187, 192, 42)",
          pointRadius: 2,
          pointBackgroundColor: "rgba(187, 192, 42, 0.2)",
          pointBorderColor: "rgb(187, 192, 42)",
          pointHoverRadius: 5,
          pointHoverBackgroundColor: "rgb(187, 192, 42)",
          pointHitRadius: 50,
          pointBorderWidth: 2,
          data: [],
          type: "line",
          order: 2,
          yAxisID: "current",
        },
      ],
    },
    options: {
      maintainAspectRatio: false,
      scales: {
        x: {
          display: true,
          stacked: true,
          title: {
            display: true,
            text: "時間",
          },
          ticks: {
            callback(value, index, ticks) {
              if (index % 6 === 0) {
                return logConfig.data.labels[index];
              }
            },
          },
        },
        y: {
          type: "linear",
          position: "left",
          suggestedMin: 0,
          suggestedMax: 10,
          ticks: {
            callback: (value, values, ctx) => {
              return value.toFixed(2);
            },
          },
          display: true,
          title: {
            display: true,
            text: "功率(KWatt)",
          },
        },
        current: {
          type: "linear",
          position: "right",
          grid: {
            display: false,
          },
          suggestedMin: 0,
          suggestedMax: 50,
          ticks: {
            callback: (value, values, ctx) => {
              return value.toFixed(2);
            },
          },
          display: true,
          title: {
            display: true,
            text: "電流(Ampere)",
          },
        },
      },
      plugins: {
        // 移到點上的提示框，顯示點的時間
        tooltip: {
          callbacks: {
            title(context) {
              return (
                logConfig.data.times[context[0].dataIndex] ??
                logConfig.data.labels[context[0].dataIndex]
              );
            },
            label(context) {
              if (context.dataset.label == "電流(Ampere)") {
                return " " + context.raw + " " + "A";
              } else {
                return " " + context.raw + " " + "KWatt";
              }
            },
          },
        },
      },
    },
  };

  if (!!electricity) {
    electricity.forEach((value) => {
      logConfig.data.times.push(value.unit ?? value.time);
      logConfig.data.labels.push(value.time);
      logConfig.data.datasets[0].data.push(
        value.power === "" ? null : value.power
      );
      logConfig.data.datasets[1].data.push(
        value.current === "" ? null : value.current
      );
    });
  }

  let ctx = document.getElementById(`electricCurrentChart${chart_id}`);
  window["myElectricCurrentChart" + chart_id] = new Chart(ctx, logConfig);
}
